import { WifiOff } from "lucide-react";
import { useOnlineStatus } from "@/hooks/useOnlineStatus";
import { cn } from "@/lib/cn";

export function OfflineBanner({ className }: { className?: string }) {
  const isOnline = useOnlineStatus();

  if (isOnline) return null;

  return (
    <div
      className={cn(
        "fixed inset-x-0 top-0 z-[9999] flex items-center justify-center gap-2 bg-[var(--color-warning)] px-4 py-2 text-sm font-medium text-[var(--color-warning-fg)] shadow-md",
        className,
      )}
    >
      <WifiOff className="h-4 w-4" />
      <span>You are offline. Changes will sync when connection is restored.</span>
    </div>
  );
}
